import { render, staticRenderFns } from "./DashboardImage.vue?vue&type=template&id=617d7646"
import script from "./DashboardImage.vue?vue&type=script&lang=js"
export * from "./DashboardImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports